export default {
  roundOnly: true,
  checkoutFormVariant: 'd',
  planSet: 'pricing-12',
  growthbookFeatures: ['supp', 'thankyou_tips'],
};
